/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Модель для получения брендов автомобилей для поиска автозапчастей
   */
  app.CarBrands = app.Model.extend({
    /**
     * @inheritDoc
     */
    urlRoot: 'https://parts.sima-land.ru/api/v1/catalog/?dh=',
    /**
     * @inheritDoc
     */
    url: function () {
      return this.urlRoot + this.hash(location.origin);
    },
    /**
     * Создает 32 битный хеш для строки.
     *
     * @param {String} string
     * @returns {Number} хеш строки
     */
    hash: function (string) {
      var hash = 0;

      if (string.length === 0) {
        return hash;
      }

      for (var i = 0; i < string.length; i++) {
        var char = string.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
      }

      return hash;
    }
  });
})();

}.call(window));